var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#969696;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.083 -0.083)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-.083.083h20v20h-20v-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.917.708a9.381,9.381,0,0,0-1,18.708l-.042-.042V15.25c0-2.25.042-4.167.042-4.25a.545.545,0,0,1,.333-.25,3.508,3.508,0,0,1,.75-.125c.417,0,.542.042.708.208l.208.208v4.125a39.335,39.335,0,0,1-.083,4.25A9.379,9.379,0,0,0,9.917.708ZM9.458,2.917a.977.977,0,0,1,.958,0c.167.125.167.25.167,1.542,0,1.625-.042,1.708-.583,1.708s-.583-.125-.583-1.708A4.293,4.293,0,0,1,9.458,2.917ZM6.125,9.042c-1.375,0-1.625-.083-1.75-.458a.627.627,0,0,1,.375-.75,11.89,11.89,0,0,1,1.5-.042c1.458,0,1.542.042,1.542.667C7.75,9,7.583,9.042,6.125,9.042ZM8.042,6.708c-.417.333-.583.25-1.458-.625C5.375,4.917,5.25,4.625,5.708,4.208c.333-.333.542-.25,1.583.792.833.833.958,1,.958,1.25A.4.4,0,0,1,8.042,6.708Zm2.792,2.333a1.341,1.341,0,0,1-1.792-.167,1.137,1.137,0,0,1,.292-1.667,1.73,1.73,0,0,1,1.292,0A1.356,1.356,0,0,1,10.833,9.042Zm1.708-4C13.583,4,13.833,3.875,14.208,4.25c.333.333.25.583-.375,1.292a6.471,6.471,0,0,1-1.542,1.333c-.125.042-.25,0-.458-.167C11.375,6.292,11.417,6.125,12.542,5.042Zm1.208,4c-1.5-.042-1.625-.083-1.625-.625,0-.375.125-.542.375-.583a10.713,10.713,0,0,1,1.458-.042c1.458,0,1.542.042,1.542.625C15.5,9.042,15.375,9.083,13.75,9.042Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagine);
export default __webpack_public_path__ + "static/media/imagine.f90ad3ad2ba0badffe2675b5d5988a4c.svg";
export { ForwardRef as ReactComponent };